import { ZONE_PAGES } from "./seoZones";
import { SERVICE_PAGES } from "./seoServices";

export const ALL_SEO_PAGES = [
  ...ZONE_PAGES.map((p) => ({ ...p, category: "zone" })),
  ...SERVICE_PAGES.map((p) => ({ ...p, category: "servizio" })),
];

export const SEO_BY_SLUG = Object.fromEntries(ALL_SEO_PAGES.map((p) => [p.slug, p]));

export const ZONE_LINKS = ZONE_PAGES.map((p) => ({ slug: p.slug, label: p.h1 }));
export const SERVICE_LINKS = SERVICE_PAGES.map((p) => ({ slug: p.slug, label: p.h1 }));

export function getRelated(page) {
  return (page.related || []).map((s) => SEO_BY_SLUG[s]).filter(Boolean);
}
